import { render, staticRenderFns } from "./banknotes.vue?vue&type=template&id=5534c15e"
import script from "./banknotes.vue?vue&type=script&lang=js"
export * from "./banknotes.vue?vue&type=script&lang=js"
import style0 from "./banknotes.vue?vue&type=style&index=0&id=5534c15e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports